import { AssetDto, AssetVersionDto } from '@nusign/picflow-backend-types';
import { isImagesBucketAsset } from './is-images-bucket-asset';

export const calcOriginalUrl = (cdn: string, asset: AssetDto, version: AssetVersionDto) => {
  if (asset.type === 'image' && isImagesBucketAsset(asset, version)) {
    return `${cdn}/images/${version.original_key}`;
  }
  if (asset.type === 'video') {
    return `${cdn}/videos/${version.original_key}`;
  }
  return `${cdn}/assets/${version.original_key}`;
};
